import * as XLSX from "xlsx";

export const exportToExcel = (data, fileName, isBuffer = false) => {
  return new Promise((resolve, reject) => {
    try {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      if (isBuffer) {
        // Convert to buffer (for email attachment)
        const excelBuffer = XLSX.write(workbook, {
          type: "array",
          bookType: "xlsx",
        });
        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        resolve(blob);
      } else {
        // Save as a file (for download)
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
        resolve("Excel file exported successfully!");
      }
    } catch (error) {
      reject("Failed to export Excel file.");
    }
  });
};
